module.exports = __webpack_public_path__ + "static/media/SevenG_01.3fbcdd78.jpg";